var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eg-radio-checkbox-input',_vm._g(_vm._b({attrs:{"type":"radio"}},'eg-radio-checkbox-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }